import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, Observable, of } from "rxjs";
import { HomeService } from "../services/home.service";
import { Quote } from "../../shared/models/quote.interface";
import { settings } from "../../shared/constants/settings";
import { catchError, finalize } from "rxjs/operators";
import { LeadFilter } from "../../lead/models/lead.filter";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";

export class HomesDataSource implements DataSource<Quote> {
  private leadsSubject = new BehaviorSubject<Quote[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  sort: MatSort;
  paginator: MatPaginator;

  constructor(private homeService: HomeService) { }

  connect(collectionViewer: CollectionViewer): Observable<Quote[]> {
    return this.leadsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.leadsSubject.complete();
    this.loadingSubject.complete();
  }

  loadLeads(leadFilter: LeadFilter,
    sortColumn = 'projectName', sortDirection = 'asc', pageIndex = 0, pageSize = 5) {

    this.loadingSubject.next(true);

    this.homeService.getLeads(leadFilter, sortColumn, sortDirection, pageIndex, pageSize).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(lessons => this.leadsSubject.next(lessons));
  }
}
